// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: '',
  stripePublicKey: 'pk_test_51JzcwJSGhhYhr9sswPWUzKBom67BtgmtSv7fBqSoHy3fd2TVTfb3LbPg0PYoi490UZVLgq4iKOJFLut9omFhQX9P00GtXS7QQO',
  googleMapsAPIKey: 'AIzaSyCn_F2BivSDtkAlLpOSYlchla839xsiGcU',
  chatServer: 'wss://appraisal.infurotech.com/api/agents',
  localChatServer: 'ws://localhost:8000'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
